<div class="advertisement">
  <div #adContainer></div>
</div>